module.exports = "<!--component html goes here -->\r\n<modal #printViewer class=\"report \">\r\n\r\n    <modal-header [show-close]=\"true\">\r\n        <h5 style=\"border-bottom: 2px solid #fed201;padding: 3px; font-weight:bold;  color:#1764a1\" class=\"modal-title\">\r\n            {{ reportTitle }}\r\n        </h5>\r\n    </modal-header>\r\n    <modal-body>\r\n\r\n        <template #report></template>\r\n\r\n    </modal-body>\r\n\r\n</modal>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ixs-printviewer/ixs-printviewer.component.html
// module id = 1047
// module chunks = 22